export default "__VITE_ASSET__B4nba89e__"